<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M103.829 51.41C103.959 51.21 104.079 51.01 104.189 50.8C106.119 47.07 104.669 42.48 100.939 40.55L81.5985 30.53C79.2385 29.31 76.4185 29.4 74.1485 30.78C73.2585 31.32 72.5185 32.03 71.9285 32.85V14.61C71.9285 10.41 68.5185 7 64.3185 7C60.1185 7 56.7085 10.41 56.7085 14.61V36.35L51.2085 17.9C50.0085 13.87 45.7785 11.58 41.7485 12.78C37.7185 13.98 35.4285 18.22 36.6285 22.24L42.6085 42.32L35.9185 32.38C33.5685 28.9 28.8485 27.97 25.3585 30.32C21.8785 32.67 20.9485 37.39 23.2985 40.88L41.1485 67.39V67.66C41.1485 67.74 41.1385 67.81 41.1385 67.89V71.24C41.1385 77.03 44.0185 82.13 48.4085 85.24V112.33H82.4085V87.38C87.9485 85.58 92.3385 81.52 95.8385 76.16C96.0485 75.92 96.2585 75.66 96.4385 75.39L105.659 61.84C107.979 58.43 107.149 53.82 103.839 51.41H103.829ZM85.6885 64.12C83.6685 65.49 80.8385 64.32 80.8285 61.57L80.7985 52.69C80.7985 50.08 83.5085 48.52 85.6885 49.8V49.78L92.8985 53.52L85.6785 64.12H85.6885Z"
      fill="#CB80DE"
    />
    <path
      d="M89.6582 114.82V108.54C89.6582 105.37 87.0883 102.8 83.9182 102.8H46.8682C43.6981 102.8 41.1282 105.37 41.1282 108.54V114.82C41.1282 117.99 43.6981 120.56 46.8682 120.56H83.9182C87.0883 120.56 89.6582 117.99 89.6582 114.82Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'LoanPromise'
  }
</script>
